import type { FunctionComponent } from "react";

import { SectionSeo } from "~/components/section/section-seo";
import { config } from "~/data";
import type { sectionSeoSection$key } from "~/queries/__generated__/sectionSeoSection.graphql";

type Props = {
  reference: sectionSeoSection$key;
};

export const SectionStyleSeo: FunctionComponent<Props> = ({ reference }) => (
  <SectionSeo
    reference={reference}
    twitter={{
      site: `@${config.social.twitter.style.accountName}`,
    }}
  />
);

SectionStyleSeo.displayName = "SectionStyleSeo";
